// Bank color configuration
const BANK_COLORS = {
  'qonto hlwc': { bg: '#e0e7ff', text: '#4f46e5' },
  'ce bahout': { bg: '#dbeafe', text: '#3b82f6' },
  'ce hlwc': { bg: '#d1fae5', text: '#10b981' },
  'laposte': { bg: '#ecfccb', text: '#65a30d' },
  'manuel': { bg: '#f5d0fe', text: '#c026d3' }
};

export default BANK_COLORS;
